import {MILESTONE_COLLECTION} from '../../projects/domain/config';
import {getCreateMilestone} from '../reducers/state';
import {makeEditMilestoneModal} from './configEditMilestoneRequests';
import {CREATE_MILESTONE_PREFIX} from './state';


export const {
  /** @type {ReduxRequestModal} */
  requestModal: createMilestoneRequestModal,
} = makeEditMilestoneModal({
  isCreate: true,
  prefix: CREATE_MILESTONE_PREFIX,
  getState: getCreateMilestone,
  path: MILESTONE_COLLECTION,
});



// WEBPACK FOOTER //
// ./src/js/milestones/redux/createMilestone.js